import React from "react";
import { CircularProgress } from "@material-ui/core";
import { useStyles } from "../../styles";

export default function Loader() {
  const classes = useStyles();
  return  <CircularProgress className={classes.loader} />;
}